import { render } from "./HomePurchases.vue?vue&type=template&id=781c020b&scoped=true"
import script from "./HomePurchases.vue?vue&type=script&lang=js"
export * from "./HomePurchases.vue?vue&type=script&lang=js"

import "./HomePurchases.vue?vue&type=style&index=0&id=781c020b&scoped=true&lang=css"
import "./HomePurchases.vue?vue&type=style&index=1&id=781c020b&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-781c020b"]])

export default __exports__